import { AddAudienceButton } from '@/features/audienceEdit/components';
import { TranslationKeys } from '@/localization';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type AudiencePageHeaderProps = {
  title: TranslationKeys | string;
  subtitle: TranslationKeys;
  hasButton?: boolean;
};

export const AudiencePageHeader: FC<AudiencePageHeaderProps> = ({ title, subtitle, hasButton = false }) => {
  const { t } = useTranslation();

  return (
    <section className='flex flex-col gap-1 border-b border-secondary-border pb-4'>
      <div className='flex flex-row items-center justify-between'>
        <div className='flex flex-col gap-1'>
          <h1 className='text-2xl font-semibold leading-8 text-primary-900'>{t(title as any)}</h1>
          <h3 className='text-tertiary-600'>
            <Trans
              i18nKey={subtitle as any}
              components={{
                newLine: <br />,
              }}
            />
          </h3>
        </div>
        {hasButton && <AddAudienceButton />}
      </div>
    </section>
  );
};
